import { render, staticRenderFns } from "./StoreageLog.vue?vue&type=template&id=72856efe&scoped=true&"
import script from "./StoreageLog.vue?vue&type=script&lang=js&"
export * from "./StoreageLog.vue?vue&type=script&lang=js&"
import style0 from "./StoreageLog.vue?vue&type=style&index=0&id=72856efe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72856efe",
  null
  
)

export default component.exports